import { Injectable } from '@angular/core';
import { CareMoniSpinnerService } from '@core/components/spinner/spinner.service';

@Injectable({
  providedIn: 'root',
})
export class MultipleSpinnerService {
  private countLoading = 0;
  private isFirstTimeAccess = true;
  constructor(private caremoniSpinnerService: CareMoniSpinnerService) { }

  show() {
    this.countLoading++;
    this.caremoniSpinnerService.isFirstTime = this.isFirstTimeAccess;
    this.caremoniSpinnerService.show();
    this.isFirstTimeAccess = false;
  }

  async hide() {
    if(this.countLoading) this.countLoading--;
    if(this.countLoading === 0) {
      await this.delay(1000);
      if (this.countLoading === 0) {
        this.caremoniSpinnerService.hide();
      }
    }
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
